import { Box, Button } from '@material-ui/core';
import React, { ReactElement } from 'react';

import { IconWithCircle } from '@/components/shared/components/IconWithCircle';
import { useCustomTheme } from '@/hooks/useCustomTheme';
import { useScreen } from '@/hooks/useScreen';

interface CustomMenuMobileProps {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  render: ReactElement;
  indentLeft?: number;
  iconProps?: MobileMenuIconProps;
  menuStyle?: React.CSSProperties;
  buttonStyle?: React.CSSProperties;
}

export const CustomMenuMobile = ({
  isOpen,
  setIsOpen,
  indentLeft = 0,
  render,
  iconProps,
  menuStyle,
  buttonStyle,
}: CustomMenuMobileProps) => {
  const { palette, background } = useCustomTheme();
  const { sm } = useScreen();

  const floatingBottomButtonStyle = {
    position: 'fixed',
    bottom: '15px',
    right: `${(15 + indentLeft).toString()}px`,
    zIndex: 1000,
    borderRadius: '100px',
    ...buttonStyle,
  } as React.CSSProperties;

  const wrapperStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 800,
    height: '100%',
    borderRight: `1px solid ${palette.grey[200]}`,
    backgroundColor: background,
    transformOrigin: '0 0',
    transform: isOpen ? 'translateX(0%) skewX(0deg)' : 'translateX(-100%) skewX(-15deg)',
    opacity: isOpen ? 1 : 0,
    transition: isOpen ? 'all 0.5s' : 'all 0.4s ease-in',
  } as React.CSSProperties;

  const wrapperStyleSmallerDevices = {
    width: '100%',
    borderRight: 'none',
  } as React.CSSProperties;

  return (
    <>
      <Box
        onClick={() => {
          setIsOpen(false);
        }}
        style={{
          ...wrapperStyle,
          ...(!sm ? wrapperStyleSmallerDevices : {}),
          ...menuStyle,
        }}
      >
        {render}
      </Box>
      <Button
        style={floatingBottomButtonStyle}
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      >
        <Box
          style={{
            opacity: isOpen ? 1 : 0,
            transition: 'all 0.5s',
          }}
        >
          <MobileMenuIcon icon={'close'} bgColor={palette.secondary.main} color={palette.secondary.contrastText} />
        </Box>
        <Box
          style={{
            position: 'absolute',
            opacity: isOpen ? 0 : 1,
            transition: 'all 0.5s',
          }}
        >
          <MobileMenuIcon
            {...(iconProps
              ? iconProps
              : { icon: 'menu', bgColor: palette.primary.main, color: palette.primary.contrastText })}
          />
        </Box>
      </Button>
    </>
  );
};

export interface MobileMenuIconProps {
  icon: string;
  bgColor: string;
  color: string;
}

export const MobileMenuIcon = ({ icon, bgColor, color }: MobileMenuIconProps) => {
  return (
    <IconWithCircle
      height={50}
      width={50}
      bgcolor={bgColor}
      className="material-icons-outlined"
      iconProps={{
        style: {
          color,
          fontSize: 23,
          fontWeight: '100',
        },
      }}
    >
      {icon}
    </IconWithCircle>
  );
};
